import { render, staticRenderFns } from "./ClaimStatusDetails.vue?vue&type=template&id=e4ed5b5c"
import script from "./ClaimStatusDetails.vue?vue&type=script&lang=ts"
export * from "./ClaimStatusDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports